
































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { tagApi } from '../tag.api';
import { Tag } from '../tag';
import TagEdit from './TagEdit.vue';
import { PermissionType } from '@shared/common/types';
import { TagFormModel } from '../tag.form-model';

@Component({
  components: {
    TagEdit,
  },
})
export default class TagSelect extends Vue {
  public tags: Tag[] = [];
  public selectedTag: Tag | null = null;
  public tagText = '';
  public showTagCreationForm = false;
  public newTag: any = new TagFormModel();
  public personAutocompleteText = '';
  public PermissionType = PermissionType;

  @Prop()
  public value: any;

  @Prop({
    default: true,
  })
  public modelAsId!: boolean;

  @Prop({
    default: false,
  })
  public required!: boolean;

  @Prop()
  public selectType!: string;

  public get result(): string | Tag | null {
    if (!this.selectedTag) {
      return null;
    }

    return this.modelAsId ? this.selectedTag.id : this.selectedTag;
  }

  public async getTags(label?: string): Promise<Tag[]> {
    try {
      const result = await tagApi.findAll({ label });
      this.tags = result;
      return this.tags;
    } catch (_) {
      console.error('e', _);
      return [];
    }
  }

  public createNewTag(): void {
    this.showTagCreationForm = true;
    this.$emit('newTag', this.newTag);
  }

  public async mounted(): Promise<void> {
    await this.getTags();
    this.setModelFromValue();
  }

  @Watch('tags')
  public onTagsChange(): void {
    if (!this.selectedTag && this.inputTextIsListed()) {
      this.selectedTag = this.findTagMatchingSearch() || null;
      this.$emit('input', this.result);
    }
  }

  @Watch('value')
  public setModelFromValue(): void {
    if (this.tags.length === 0) {
      return;
    }
    // if (!this.value && this.tags.length === 1) {
    //   this.selectedTag = this.tags[0];
    //   this.tagText = this.selectedTag.label;
    //   this.$emit('input', this.result);
    //   return;
    // }

    if (this.modelAsId && this.value) {
      this.selectedTag = this.tags.find((tag) => tag.id === this.value) || null;
      if (this.selectedTag) {
        this.tagText = this.selectedTag.label;
        this.$emit('input', this.result);
      }
    } else if (!this.modelAsId && this.value) {
      this.selectedTag =
        this.tags.find((tag) => tag.id === this.value.id) || null;
      if (this.selectedTag) {
        this.tagText = this.selectedTag.label;
        this.$emit('input', this.result);
      }
    }
  }

  public onTagSelected(tag: any): void {
    this.selectedTag = tag;
    this.$emit('input', this.result);
  }

  public resetSelected(): void {
    this.selectedTag = null;
    this.$emit('input', this.result);
  }

  public onInputChange(): void {
    if (this.selectedTag && this.tagText !== this.selectedTag.label) {
      this.selectedTag = null;
      this.$emit('input', this.result);
    } else if (!this.selectedTag && this.inputTextIsListed()) {
      this.selectedTag = this.findTagMatchingSearch() || null;
      this.$emit('input', this.result);
    }

    this.getTags(this.tagText);
  }

  public onCancel(): void {
    this.showTagCreationForm = false;
    this.$emit('cancel');
  }

  public inputTextIsListed(): boolean {
    return !!this.findTagMatchingSearch();
  }

  public findTagMatchingSearch(): Tag | undefined {
    return this.tags.find((tag) => tag.label === this.tagText);
  }
}
